import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { PostAskRequest } from 'domain/usecases';
import { RemotePostAskRequest } from 'data/usecases/ask-customer';

export const makeRemotePostQueueGroupAssign = (groupId: string): PostAskRequest => {
  return new RemotePostAskRequest(
    makeApiUrl(`/queue/requests/group/${groupId}/assign`),
    makeAuthorizeHttpClientDecorator()
  );
};
